import React from "react";
import ApplicationProvider from "pages/application-provider";
import {Button, Checkbox, Flex, Text, PasswordInput, rem, SimpleGrid, TextInput, Title, Box} from "@mantine/core";
import {IconLock, IconMail} from "@tabler/icons-react";
import '@mantine/carousel/styles.css';
import CarouselOp from "components/login/CarouselOp";


interface Props {
    isAuthenticated: string;
    csrfToken: string;
    loginUrl: string;
    staticBaseUrl: string;
}

export default function LoginPage(props: Props) {


    return (
        <ApplicationProvider>
            <Flex direction='column' w={'100svw'} h={'100svh'} p={rem(16)}>

                <SimpleGrid cols={2} h={'100%'}>

                    <Flex direction={'column'} p={rem(40)}>

                        <Box maw={rem(262)} flex={1} component={'a'} href={'/'}>
                            <img src={`${props.staticBaseUrl}alone/images/logo-big.svg`}  alt="Alone"/>
                        </Box>

                        <Flex direction={'column'} gap={rem(24)} mb={rem(120)}>
                            <Title
                                fw={600}
                                fz={rem(32)}
                                lh={rem(40)}
                                c={'#171717'}
                            >
                                Welcome to <span style={{color: '#E20914'}}>Volunteer Matching</span>
                            </Title>
                            <form action={props.loginUrl} method='POST'>
                                <input type="hidden" name="csrfmiddlewaretoken"
                                       value={props.csrfToken}/>


                                <Flex direction={'column'} gap={rem(16)}>
                                    <TextInput
                                        label="Username"
                                        size="md"
                                        variant={'filled'}
                                        placeholder="Your username"
                                        name='username'
                                        leftSection={<IconMail size={20}/>}
                                        required
                                    />

                                    <PasswordInput
                                        label="Password"
                                        size="md"
                                        placeholder="Password"
                                        name='password'
                                        variant={'filled'}
                                        leftSection={<IconLock size={20}/>}
                                        required
                                    />

                                    <Flex direction={'row'} w={'100%'} justify={'space-between'} align={'center'}>
                                        <Checkbox
                                            defaultChecked
                                            label="Remember me"
                                            color="gray"
                                            size={'md'}
                                        />
                                    </Flex>

                                </Flex>


                                <Button
                                    type={'submit'}
                                    variant={'filled'}
                                    bg={'#4B49AC'}
                                    p={rem(16)}
                                    style={{borderRadius: '12px'}}
                                    h={rem(56)}
                                    w={'100%'}
                                    mt={rem(24)}
                                >
                                    <Text
                                        c={'#FFFFFF'}
                                        fz={rem(16)}
                                        lh={rem(24)}
                                        fw={500}
                                    >
                                        Login
                                    </Text>
                                </Button>
                            </form>
                        </Flex>

                    </Flex>

                    <CarouselOp staticBaseUrl={props.staticBaseUrl} />
                </SimpleGrid>

            </Flex>
        </ApplicationProvider>
    )
}